import { lazy } from "react";

/**
 * Load a named Create * export on first render so document pages do not parse
 * unused drawers.
 *
 * @param {function(): !Promise<!Object<string, *>>} importer Dynamic import.
 * @param {string} exportName Named export to use as the component.
 * @return {*}
 */
export const lazyNamedExport = (importer, exportName) =>
  lazy(() => importer().then(mod => ({ default: mod[exportName] })));
